// extracted by mini-css-extract-plugin
module.exports = {"logos__carousel":"styles_logos__carousel__Eeixt","logos__footer":"styles_logos__footer__dItCl","logos__link":"styles_logos__link__a_BDI"};